import React, { useEffect, useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { User2 } from "lucide-react";
import { SidebarTrigger } from "./ui/sidebar";
import { useNavigate } from "react-router-dom";
import { setUser } from "@/hooks/useLocalStorage";
import { useIsMobile } from "@/components/hooks/use-mobile";

function Navbar({ user }) {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [role, setRole] = useState("");

  const roleMap = {
    buyer: "Buyer",
    seller: "Seller",
    buyer_agent: "Buyer Agent",
    seller_agent: "Seller Agent",
    admin: "Administrator",
  };

  const handleRoleChange = (newRole) => {
    setUser({ ...user, role: newRole });
    navigate(0);
  };

  useEffect(() => {
    setRole(roleMap[user.role]);
  }, [user]);

  return (
    <div className="flex items-center justify-between h-[60px] px-6 bg-offwhite">
      {isMobile && <SidebarTrigger />}

      {!isMobile && (
        <h5 className="text-sm font-semibold text-green">JP ASSOCIATES</h5>
      )}

      <DropdownMenu>
        <DropdownMenuTrigger>
          <div className="flex items-center">
            <User2
              color="#49475A"
              className="p-1 h-8 w-8 rounded-full border border-[#49475A]"
            />

            <p className="text-sm text-muted ml-2">
              {user.name} ({role})
            </p>
          </div>
        </DropdownMenuTrigger>

        {(role === "Buyer" || role === "Seller") &&
          user.allowedRoles.length > 1 && (
            <DropdownMenuContent>
              <DropdownMenuLabel>My Account</DropdownMenuLabel>
              <DropdownMenuSeparator />
              {user.allowedRoles.map((allowedRole, i) => (
                <DropdownMenuItem
                  key={i}
                  className="cursor-pointer"
                  onClick={() => handleRoleChange(allowedRole)}
                >
                  {roleMap[allowedRole]}
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          )}
      </DropdownMenu>
    </div>
  );
}

export default Navbar;
